<template>
    <b-form-group
            v-if="dataIsVisible"
            class="c-select"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <b-form-input
                v-if="dataReadOnly"
                type="text"
                :readonly="true"
                v-model="Core.Select.label(dataValue)"></b-form-input>
        <v-select v-else-if="required" v-model="dataValue"
                  :multiple="true"
                  :closeOnSelect="false"
                  :options="dataOptions"
                  :placeholder="placeholder">
            <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
        </v-select>
        <v-select v-else v-model="dataValue"
                  :multiple="true"
                  :options="dataOptions"
                  :closeOnSelect="false"
                  :placeholder="placeholder">
            <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
        </v-select>

        <div v-if="required && !chkState(id)" style="display: block" class="invalid-feedback">
            <span v-if="invalidFeedbackMessage !== ''">{{invalidFeedbackMessage}}</span>
            <span v-if="invalidFeedbackMessage === ''">{{Core.Definition.getDefinition('Vous devez sélectionner au moins une valeur.')}}</span>
        </div>
    </b-form-group>
</template>

<script>
    import vSelect from 'vue-select'
  export default {
      name: 'InputMultiSelect',
      components: {
          vSelect
      },
      props: {
          options: {
              type: Array,
              default: function() {
                  return []
              }
          },
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: Array,
              default: function() {
                  return null
              }
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          _isVisible: {
              type: Boolean,
              default: true
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
              this.$emit('onSelect', val, this.form.$model, this.fieldRefs)
          },
          options(val) {
              this.dataOptions = val
          }
      },
      mounted() {
          this.dataIsVisible = this._isVisible
          this.dataValue = this.value
          this.dataOptions = this.options
          this.dataReadOnly = this.readOnly
      },
      data: () => {
          return {
              Core: window.Core,
              dataValue: '',
              dataOptions: [],
              dataIsVisible: true,
              dataReadOnly: true
          }
      },
      computed: {
          isReadOnly: {
              set(val) {
                  this.dataReadOnly = val
              },
              get() {
                  return this.dataReadOnly
              }
          },
          isVisible: {
              set(val) {
                  this.dataIsVisible = val
              },
              get() {
                  return this.dataIsVisible
              }
          }
      },
      methods: {
          setOptions(options) {
              this.dataOptions = options
          },
          getOptions() {
              return this.dataOptions
          },
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>